module.exports = __webpack_public_path__ + "static/media/product1.6ccb778a.png";